import React from "react";

export default function Project() {
  return <div>Coming soon...</div>;
}
